import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Funciona si mi hijo ya está muy acostumbrado a las pantallas?',
  a: 'Sí. El sistema está diseñado específicamente para hacer una transición suave. No se trata de quitar la pantalla de golpe (lo que causa berrinches), sino de ofrecer una alternativa más atractiva que satisface su necesidad de juego.',
  color: 'red'
}, {
  q: '¿Cuánto tiempo necesito para implementarlo?',
  a: 'Menos de 10 minutos para leer la guía rápida. Las actividades están listas para usar. La idea es que te ahorre tiempo, no que te dé más trabajo.',
  color: 'yellow'
}, {
  q: '¿Necesito comprar materiales especiales?',
  a: 'No. Todas las actividades usan cosas que ya tienes en casa (papel, lápices, juguetes básicos, cojines). El sistema se basa en la creatividad, no en el consumo.',
  color: 'green'
}, {
  q: '¿Es compatible con mi estilo de crianza?',
  a: 'Absolutamente. Es respetuoso, sin castigos y fomenta la autonomía. Funciona tanto si eres estricta con las rutinas como si prefieres un estilo más libre.',
  color: 'orange'
}, {
  q: '¿Qué edad es ideal?',
  a: 'Está optimizado para niños de 3 a 9 años. Para niños más pequeños hay adaptaciones incluidas, y para los mayores sirve como base para negociar tiempos.',
  color: 'red'
}, {
  q: '¿Es digital o físico?',
  a: 'Es un producto 100% digital de acceso inmediato. Puedes ver las tarjetas en tu celular o imprimirlas (recomendado) para tenerlas a mano.',
  color: 'yellow'
}, {
  q: '¿Qué pasa si no funciona para mí?',
  a: 'Tienes nuestra garantía de 30 días. Si no ves cambios, nos escribes un correo y te devolvemos tu dinero íntegro.',
  color: 'green'
}];
const colorClasses = {
  red: 'border-brand-red/30 bg-brand-red/5',
  yellow: 'border-brand-yellow/30 bg-brand-yellow/5',
  green: 'border-brand-green/30 bg-brand-green/5',
  orange: 'border-brand-orange/30 bg-brand-orange/5'
};
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-cream" data-id="element-99">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-100">
        <div className="text-center mb-12" data-id="element-101">
          <h2 className="text-3xl font-bold text-brand-navy mb-4 font-serif" data-id="element-102">
            Preguntas Frecuentes
          </h2>
          <p className="text-slate-700" data-id="element-103">
            Resolvemos tus dudas antes de empezar
          </p>
        </div>

        <div className="space-y-4" data-id="element-104">
          {faqs.map((faq, i) => <div key={i} className={`bg-brand-offwhite rounded-xl shadow-sm border-l-4 overflow-hidden ${colorClasses[faq.color as keyof typeof colorClasses]}`} data-id="element-105">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-106">
                <span className="font-bold text-brand-navy pr-4" data-id="element-107">{faq.q}</span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-red flex-shrink-0" data-id="element-108" /> : <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-109" />}
              </button>

              <AnimatePresence data-id="element-110">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-111">
                    <div className="px-6 pb-6 text-slate-700 leading-relaxed border-t border-brand-wood/10 pt-4" data-id="element-112">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}